import { createFileRoute } from "@tanstack/react-router";
import { StakePage } from "../../features/rewards/pages/stake-page";
import { assetRouteLoader } from "../../features/rewards/utils/route-loaders";

export const Route = createFileRoute("/_layout/rewards/$asset/stake/$vault")({
  loader: assetRouteLoader,
  component: StakePage,
});
